import { dentedRect } from './pathUtils'

const convertConstToFunc = x =>
  function () {
    return x
  }

//Draw dentedRect
export function drawDentedRect(selection, size, status = 'enter') {
  switch (status.toLowerCase()) {
    case 'enter':
      return selection.append('path').attr('d', () => {
        return dentedRect(size, size, {
          dents: ['br', 'tl'],
          lengths: { tl: size, tr: size, bl: size, br: size },
          forcedDentSize: 3,
          barWidth: size,
        })
      })
    case 'edit':
    case 'exit':
    default:
      selection.select('path').attr('d', () => {
        // return dentedRect(rect.width, rect.height, , null, 4)
        // return dentedRect(rect.width, rect.height, ['br','tl'], null, 3,{tl:0,tr:0,bl:0,br:0}, {tl:4,tr:4,bl:4,br:4}, 4)
        return dentedRect(size, size, {
          dents: ['br', 'tl'],
          lengths: { tl: size, tr: size, bl: size, br: size },
          forcedDentSize: 3,
          barWidth: size,
        })
      })
  }
}

//Circle
export function drawSvgCircle(selection, r = 0, status = 'enter') {
  r = typeof r === 'function' ? r : convertConstToFunc(r)
  switch (status.toLowerCase()) {
    case 'enter':
      return selection.append('circle').attr('r', r)
    case 'edit':
    case 'exit':
    default:
      return selection.select('circle').attr('r', r)
  }
}

//Square
export function drawSvgSquare(selection, size, status = 'enter') {
  size = typeof size === 'function' ? size : convertConstToFunc(size)
  switch (status.toLowerCase()) {
    case 'enter':
      return selection.append('rect').attr('height', 0).attr('width', 0)
    case 'edit':
    case 'exit':
    default:
      return selection
        .select('rect')
        .attr('height', size)
        .attr('width', size)
        .attr('y', d => -size(d) / 2)
        .attr('x', d => -size(d) / 2)
  }
}

//Triangle
export function drawSvgTriangle(selection, size, status = 'enter') {
  size = typeof size === 'function' ? size : convertConstToFunc(size)
  switch (status.toLowerCase()) {
    case 'enter':
      return selection.append('polygon').attr('points', '0,0 0,0 0,0')
    case 'edit':
    case 'exit':
    default:
      return selection
        .select('polygon')
        .attr(
          'points',
          d => `0,${-size(d) / 2} ${size(d) / 2},${size(d) / 2} ${-size(d) / 2},${size(d) / 2}`
        )
  }
}

//Star
export function drawSvgStar(selection, size, numPoints, status = 'enter') {
  size = typeof size === 'function' ? size : convertConstToFunc(size)
  switch (status.toLowerCase()) {
    case 'enter':
      return selection.append('polygon').attr(
        'points',
        Array.from(Array(numPoints * 2).keys())
          .map(() => '0,0')
          .join(' ')
      )
    case 'edit':
      const getPoints = d => {
        var outerRadius = size(d) / 2
        var innerRadius = size(d) / 4

        var center = Math.max(innerRadius, outerRadius)
        var angle = Math.PI / numPoints
        var points = []

        for (var i = 0; i < numPoints * 2; i++) {
          var radius = i & 1 ? innerRadius : outerRadius
          points.push(center + radius * Math.sin(i * angle) - size(d) / 2)
          points.push(center - radius * Math.cos(i * angle) - size(d) / 2)
        }
        return points
      }
      return selection.select('polygon').attr('points', getPoints)
    case 'exit':
    default:
      return selection.select('polygon').attr(
        'points',
        Array.from(Array(numPoints * 2).keys())
          .map(() => '0,0')
          .join(' ')
      )
  }
}

//Polygon
export function drawSvgPolygon(selection, size, sides, status = 'enter') {
  size = typeof size === 'function' ? size : convertConstToFunc(size)
  switch (status.toLowerCase()) {
    case 'enter':
      return selection.append('polygon').attr(
        'points',
        Array.from(Array(sides).keys())
          .map(() => '0,0')
          .join(' ')
      )
    case 'edit':
      const getPoints = d => {
        var radius = size(d) / 2
        var angle = (2 * Math.PI) / sides
        var points = []

        for (var i = 0; i < sides; i++) {
          points.push(radius + radius * Math.sin(i * angle) - size(d) / 2)
          points.push(radius - radius * Math.cos(i * angle) - size(d) / 2)
        }
        return points
      }

      return selection.select('polygon').attr('points', getPoints)
    case 'exit':
    default:
      return selection.append('polygon').attr(
        'points',
        Array.from(Array(sides).keys())
          .map(() => '0,0')
          .join(' ')
      )
  }
}

//Plus
export function drawSvgPlus(selection, size, status = 'enter') {
  size = typeof size === 'function' ? size : convertConstToFunc(size)
  switch (status.toLowerCase()) {
    case 'enter':
      selection
        .append('line')
        .attr('class', 'line')
        .attr('x1', d => -size(d) / 2)
        .attr('x2', d => size(d) / 2)
        .attr('y1', 0)
        .attr('y2', 0)
        .attr('stroke-width', 2)
        .style('opacity', 0)

      selection
        .append('line')
        .attr('class', 'line')
        .attr('y1', d => -size(d) / 2)
        .attr('y2', d => size(d) / 2)
        .attr('x1', 0)
        .attr('x2', 0)
        .attr('stroke-width', 2)
        .style('opacity', 0)
      return selection
    case 'edit':
      return selection
        .selectAll('.line')
        .attr('y1', (d, i) => (i === 0 ? 0 : -size(d) / 2))
        .attr('y2', (d, i) => (i === 0 ? 0 : size(d) / 2))
        .attr('x1', (d, i) => (i === 0 ? -size(d) / 2 : 0))
        .attr('x2', (d, i) => (i === 0 ? size(d) / 2 : 0))
        .style('opacity', 1)
    case 'exit':
    default:
      return selection.selectAll('.line').style('opacity', 0)
  }
}

export const SHAPES = [
  'triangle',
  'square',
  'circle',
  'fivePointStar',
  'sixPointStar',
  'hexagon',
  'pentagon',
  'plus',
]

export function getShapeByIndex(index) {
  const wrappedIndex = index % SHAPES.length
  return SHAPES[wrappedIndex]
}
